import React from "react";
import { useWatchState } from "@/store";
import { Avatar } from "@/components";
import courseLogo from "./images/courseLogo.png";
import "./style.less";

function CourseHead() {

    const [[{ IS_LOGIN, info }]] = useWatchState(["user"])

    return (
        <section className="module-course__head l-main flex ver between">
            <p className="flex ver">
                <img className="module-course__head__logo" src={courseLogo} alt="" />
                <span className="module-course__head__title m-sm-l">产业技术云课堂</span>
                <span className="module-course__head__region">石家庄</span>
            </p>
            {IS_LOGIN ? <div className="child-left-sm flex ver">
                <a className="dark-disable">{info.nickname || info.account}</a>
                <Avatar url={info.avatar} width="30px" />
            </div> : <div className="child-left-sm">
                    <a className="dark-disable">登录</a>
                    <span>|</span>
                    <a className="color-primary">新用户注册</a>
                    <img src="" alt="" />
                </div>}
        </section>
    )
}

export default CourseHead;